import {CLEAR_ERRORS, RECEIVE_CURRENT_USER, RECEIVE_ERRORS} from "../../actions/actionTypes";

const DEFAULT_ERROR = {
  message: "",
  errors: []
};


export default (state = DEFAULT_ERROR, action) => {
  Object.freeze(state);
  switch (action.type) {
    case RECEIVE_ERRORS:
      return action.payload;
    case RECEIVE_CURRENT_USER:
    case CLEAR_ERRORS:
      return DEFAULT_ERROR;
    default:
      return state;
  }
};